<template>
  <div class="tabBox">
    <div v-for="(item, i) in props?.data" :key="i">
      <div class="title">
        {{ item?.data?.title }}
      </div>
      <a-row
        :gutter="[50, 30]"
        v-if="item?.data?.content && item?.data?.content.length > 0"
        v-for="(item2, i2) in item?.data?.content"
        :key="i2"
        class="rowBox"
      >
        <a-col
          :span="24"
          v-if="item2.text && parseList(item2.text).length > 1"
          v-for="(text, index) in parseList(item2.text)"
          :key="index"
        >
          <span class="name">· {{ text }}</span>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
    default: () => {},
  },
});

const parseList = (str) => {
  return JSON.parse(str);
};
</script>

<style lang="less" scoped>
.tabBox {
  > div {
    .title {
      margin-bottom: 30px;
      .fcf(28,#fff,600);
    }
    .name {
      .fcf(24,#ccc);
      .lh(30);
    }
    .list {
      // display: grid;

      .list-item {
      }
    }
  }
  > div + div {
    margin-top: 60px;
  }
}

@media (max-width: 1024px) {
  .tabBox {
    > div {
      .title {
        margin-bottom: 30px;
        .fcf(18,#fff,600);
      }
      .name {
        .fcf(14,#ccc);
        .lh(23);
      }
    }

    .rowBox {
      row-gap: 10px !important;
    }
  }
}
</style>
